import { PersonCategoryService, ReasonService } from '@general/proxy/general/controllers';
import { VendorPerPerson } from '@general/vendor-per-person/vendor-per-person';
import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { InternalOrderService } from '@controlling/proxy/controlling/controllers';

FieldBuilder.setNamespace('General');

export const PERSON_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Person.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('lastName', 'Entity.Person.LastName')
    .required()
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Person.Code')
    .maxLength(20)
    .build(),
  FieldBuilder
    .checkbox('isActive', 'Entity.VendorPerPerson.IsActive')
    .build(),
  FieldBuilder
    .foreignKey('deactivationReasonId', 'Entity.Person.DeactivationReason', ReasonService)
    .displayFromNested('deactivationReason.name')
    .sortBy('deactivationReason.name')
    .build(),
  FieldBuilder
    .date('deactivationDate', 'Entity.Person.DeactivationDate')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('internalOrderId', 'Entity.InternalOrder', InternalOrderService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .text('notes', 'Entity.Person.Notes')
    .maxLength(300)
    .build(),
  FieldBuilder
    .foreignKey('personCategoryId', 'Entity.PersonCategory', PersonCategoryService)
    .required()
    .displayFromNested('personCategory.name')
    .sortBy('personCategory.name')
    .build(),
  FieldBuilder
    .text('identityNumber', 'Entity.Person.IdentityNumber')
    .required()
    .maxLength(100)
    .build(),
];

export const PERSON_CONFIG = {
  entityName: 'Person',
  localizationKey: 'General::Entity.Person',
  fields: PERSON_FIELDS,
  permission: 'GeneralPersons.Persons',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Persons + MENU_NAME_SUFFIX,
  children: [
    {
      entityName: 'VendorPerPerson',
      foreignKeyField: 'personId',
      localizationKey: 'General::Entity.VendorPerPerson',
      component: VendorPerPerson,
    },
  ]
};
